export const FREE_PLAN_LIMITS = {
  BOOKMARKS: 1000,
  FEEDS: 10
}

export const PRO_PLAN_LIMITS = {
  PRICE_ALERTS: 50
}

export const PRICE_ALERT_RULE_TYPES = [
  { label: 'Price drops below', value: 'BELOW' },
  { label: 'Price rises above', value: 'ABOVE' },
  { label: 'Price drops by %', value: 'DROP_PERCENT' },
  { label: 'Any price change', value: 'ANY_CHANGE' }
]

// Host that serves rehosted (user-uploaded) images. Centralized so a domain
// change touches one place instead of scattered regexes/string checks (L6).
export const HOSTED_IMAGE_HOST = 'img.linkflare.io'
export const HOSTED_IMAGE_BASE = `https://${HOSTED_IMAGE_HOST}/`

/**
 * Build a fresh regex matching <img> tags whose src is NOT under the hosted
 * image base — used to strip base64 junk and external hotlinks from notes.
 * Returns a NEW regex each call (the global flag is stateful via lastIndex).
 */
export function buildNonHostedImageRegex() {
  const host = HOSTED_IMAGE_HOST.replace(/\./g, '\\.')
  return new RegExp(
    `<img[^>]+src\\s*=\\s*["'](?!https:\\/\\/${host}\\/)[^"']*["'][^>]*\\/?>`,
    'gi'
  )
}
